import { sampleSize } from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

import AvatarStack from "@/components/avatar-stack";
import { Text } from "@/components/ui";
import { useAuth } from "@/contexts/auth/useAuth";
import { useModalContext } from "@/contexts/modal-context";
import { cn } from "@/utils/cn";
import { shortNumberFormat } from "@/utils/numbers";

import type { Group } from "@/schemas";

interface GroupMemberCountProps {
  group: Group;
}

const GroupMemberCount = ({ group }: GroupMemberCountProps) => {
  const { openModal } = useModalContext();
  const { currentAccount } = useAuth();

  const handleOpenModal = () => {
    openModal("GROUP_MEMBERS", { group });
  };

  const avatars = sampleSize(group.member_avatars, 3).map(
    (avatar) => avatar.avatar,
  );

  return (
    <button
      onClick={handleOpenModal}
      className={"group flex items-center space-x-2.5"}
      disabled={!currentAccount}
    >
      <AvatarStack avatars={avatars} size={20} withRing />
      <Text
        theme="inherit"
        tag="span"
        className={cn({ "group-hover:underline": currentAccount })}
        size="sm"
        weight="medium"
        data-testid="group-member-count"
      >
        {shortNumberFormat(group.members_count)}{" "}
        <FormattedMessage
          id="groups.discover.search.results.member_count"
          defaultMessage="{members, plural, one {member} other {members}}"
          values={{
            members: group.members_count,
          }}
        />
      </Text>
    </button>
  );
};

export default GroupMemberCount;
